import loadComponent from './component';
import loadCommands from './commands';
import chartLineUpDownIcon from './icons/chart-line-up-down.svg';
import { componentLabel, customComponentsCategory } from '../utils/editor';

function loadBlock(editor, options = {}) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, chartLineUpDownIcon),
    category: options.category,
    content: '<NvChart />'
  });
}

export default function initNvChart(editor, opts = {}) {
  const defaults = {
    componentType: 'NvChart',
    componentName: 'Chart',
    modalTitle: 'Chart configuration',
    category: customComponentsCategory,
    formElementID: 'nv-chart-settings-form',
    componentKey: 'nv_chart_settings',
    commands: {
      configure: 'nv-charts:settings:open-modal',
      exportConfig: 'nv-charts:config:export',
      importConfig: 'nv-charts:config:import',
    }
  };

  loadCommands(editor, {...defaults, ...opts});
  loadBlock(editor, {...defaults, ...opts});
  loadComponent(editor, {...defaults, ...opts});
}
